import React, { Fragment } from "react";
import { Props } from "./types";

const Radio = (
  {
    options,
    name,
    error,
    onChange,
    onBlur,
    className,
    containerClass,
    isMultiple = false,
    noPadding = false,
    noMargin = false,
    hasCheckboxIcon = false,
    lineBreakIndex,
  }: Props,
  ref: React.Ref<HTMLInputElement> | undefined,
) => {
  const onKeyDown = (e: React.KeyboardEvent<HTMLLabelElement>) => {
    if (e.code === "Space" || e.code === "Enter") {
      e.preventDefault();
      const forAttribute = e.currentTarget.getAttribute("for") || "";
      document.getElementById(forAttribute)?.click();
    }
    if (e.code === "ArrowRight") {
      const nextSibling =
        e.currentTarget.parentElement?.nextElementSibling?.getElementsByTagName("LABEL");
      if (nextSibling && nextSibling.length) {
        (nextSibling[0] as HTMLElement).focus();
      }
    }
    if (e.code === "ArrowLeft") {
      const prevSibling =
        e.currentTarget.parentElement?.previousElementSibling?.getElementsByTagName("LABEL");
      if (prevSibling && prevSibling.length) {
        (prevSibling[0] as HTMLElement).focus();
      }
    }

    if (e.code === "ArrowDown") {
      const nextRow =
        e.currentTarget.parentElement?.parentElement?.parentElement?.nextElementSibling?.getElementsByTagName(
          "LABEL",
        );

      if (nextRow && nextRow.length) {
        (nextRow[0] as HTMLElement).focus();
      }
    }

    if (e.code === "ArrowUp") {
      const prevRow =
        e.currentTarget.parentElement?.parentElement?.parentElement?.previousElementSibling?.getElementsByTagName(
          "LABEL",
        );

      if (prevRow && prevRow.length) {
        (prevRow[0] as HTMLElement).focus();
      }
    }
  };
  return (
    <div className={noMargin ? "mb-0" : "mb-6 md:mb-8"}>
      <div className={`flex flex-wrap justify-around ${containerClass}`}>
        {options.map((option, idx) => (
          <Fragment key={idx}>
            <div
              className={` ${className} flex-1 w-[0px] mr-3 basis-[82px] transition-all duration-300 justify-between ease-in-out  mt-4`}
            >
              <input
                name={name}
                type={isMultiple ? "checkbox" : "radio"}
                value={option.value}
                id={`${name}_${idx}`}
                ref={ref}
                className={`input-checked-check h-0 absolute ${
                  !isMultiple ? "m-0 appearance-none" : ""
                }`}
                onChange={onChange}
                onBlur={onBlur}
                tabIndex={-1}
              />
              <label
                htmlFor={`${name}_${idx}`}
                tabIndex={0}
                id={`${name}_${idx}_label`}
                onKeyDown={onKeyDown}
                className={` h-[72px] flex justify-center items-center border font-bold text-center outline-offset-2 bg-white  rounded cursor-pointer select-none text-grey-600 label-checked-check ${
                  noPadding ? "px-2" : "px-6"
                }
            ${option.caption.length > 3 ? "text-base md:text-lg " : "text-lg"}
            ${
              error
                ? "border-error-border  bg-error-border bg-opacity-25 text-error-value"
                : " border-gray-400"
            }`}
              >
                {hasCheckboxIcon && (
                  <>
                    <svg
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="hidden mr-2 svg-label-checked-check"
                    >
                      <path
                        d="M6.25 13.2231L8.7 16.7001C8.79293 16.8389 8.91768 16.9536 9.06385 17.0344C9.21002 17.1153 9.37339 17.1601 9.54037 17.1651C9.70735 17.1701 9.8731 17.1351 10.0238 17.0631C10.1746 16.9911 10.3059 16.8841 10.407 16.7511L18.25 6.82812"
                        stroke="#A4B1C2"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M22 0.749023H2.5C1.67157 0.749023 1 1.4206 1 2.24902V21.749C1 22.5774 1.67157 23.249 2.5 23.249H22C22.8284 23.249 23.5 22.5774 23.5 21.749V2.24902C23.5 1.4206 22.8284 0.749023 22 0.749023Z"
                        stroke="#A4B1C2"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <svg
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="flex mr-2 svg-label-checked-uncheck"
                    >
                      <path
                        d="M22 0.749023H2.5C1.67157 0.749023 1 1.4206 1 2.24902V21.749C1 22.5774 1.67157 23.249 2.5 23.249H22C22.8284 23.249 23.5 22.5774 23.5 21.749V2.24902C23.5 1.4206 22.8284 0.749023 22 0.749023Z"
                        stroke="#A4B1C2"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </>
                )}

                {option.caption}
              </label>
            </div>
            {idx === lineBreakIndex && (
              <hr className="relative hidden w-full opacity-0 xxs:inline-block md:hidden"></hr>
            )}
          </Fragment>
        ))}
      </div>

      <div
        className={`mt-2 text-base transition-all duration-300 ease-in-out transform ${
          error ? "inline-block text-error-border opacity-100" : "opacity-0"
        }`}
      >
        {error}
      </div>
    </div>
  );
};

export default React.forwardRef(Radio);
